<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <span class="screenHeading mt-4"
          >{{ $t('MOCs') }}

          <v-progress-circular width="2" size="20" color="gray" class="ml-1" indeterminate v-if="loading"></v-progress-circular>
          <span v-else>({{ totalItems }})</span>
        </span>
      </v-col>
      <v-col cols="12">
        <v-data-table-server
          :key="tableKey"
          :headers="headers"
          :items="mocs"
          class="elevation-0"
          style="border: solid 1px;"
          :items-per-page-options="pagination['items-per-page-options']"
          :options.sync="options"
          :sort-by="options.sortBy"
          :sort-desc="options.descending"
          :loading="loading"
          :items-length="totalItems"
          @update:options="(event) => updateOptions(event)"
          multi-sort
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <router-link
                  class="blue-link"
                  :to="{
                    path: `/${community.communityAbbreviation}/moc/${props.item.mocId}`
                  }"
                  >{{ props.item.mocId }}</router-link
                >
              </td>
              <td>{{ props.item.title }}</td>
              <td>
                <span>
                  {{ props.item.status.name }}
                </span>
                <ArchiveButton v-if="isClosed(props.item.status)" :mocId="props.item.mocId" />
              </td>
              <td>{{ props.item.changeCategory }}</td>
              <td>{{ props.item.roles.initiator.displayName }}</td>
              <td>{{ $filters.DateFilter(props.item.dates.initiated) }}</td>
              <td>{{ $filters.DateFilter(props.item.dates.submitted) }}</td>
            </tr>
          </template>
        </v-data-table-server>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import mocStatusMixins from '@/mixins/mocStatusMixins'
import MOCService from '@/services/moc.service'
import TaskService from '@/services/task.service'
import ApprovalService from '@/services/approval.service'
import ArchiveButton from '@/components/archive/ArchiveButton'
import axios from 'axios'

export default {
  name: 'MocList',
  mixins: [mocStatusMixins],
  components: {
    ArchiveButton
  },
  data() {
    return {
      tableKey:0,
      headers: [
        { title: this.$t('MOC_ID'), key: 'MocId', width: '10%', sortable: false },
        {
          title: this.$t('Title'),
          key: 'title',
          width: '15%',
          sortable: false
        },
        { title: this.$t('Status'), key: 'Status.name', width: '15%' },
        { title: this.$t('Change_Category'), key: 'changeCategory', sortable: false },
        { title: this.$t('Initiator'), key: 'roles.initiator.displayName', width: '15%', sortable: false },
        { title: this.$t('Date_Initiated'), key: 'Dates.initiated', width: '10%' },
        { title: this.$t('Date_Submitted'), key: 'Dates.submitted', width: '10%' }
      ],

      pagination: {
        'items-per-page-options': [
  {value: 10, title: '10'},
  {value: 20, title: '20'},
  {value: 30, title: '30'},
  {value: 40, title: '40'}
  
]
      },
      options: {
        itemsPerPage: 10,
        // sortBy: ['Dates.initiated'],
        sortBy: [{ key: 'Dates.initiated', order: 'desc' }],
        descending: true,
        page: 1,
        sortDesc: [true]
      },
      totalItems: 0,
      loading: false,
      mocs: [],
      defaultOptions: {
        itemsPerPage: 10,
        // sortBy: ['Dates.initiated'],
        sortBy: [{ key: 'Dates.initiated', order: 'desc' }],
        descending: true,
        page: 1,
        sortDesc: [true]
      },
      cancelTokens: []
    }
  },
  props: {
    selectedCategory: {
      type: String,
      default: null
    },
    community: {
      type: Object,
      default: null
    }
  },
  methods: {
    updateOptions(event) {
      console.log(`updateOptions ${JSON.stringify(event, null, 4)}`)
      this.options.sortBy = event.sortBy
      this.options.page = event.page
      this.options.itemsPerPage = event.itemsPerPage
      this.options.sortDesc = event.sortBy.map((x) => x.order === 'desc')
      this.getItems(this.options)
    },
    cancelCalls() {
      if (this.cancelTokens) {
        this.cancelTokens.forEach(ct => {
          ct.cancel('CANCELLED_BY_USER')
        })
      }
    },
    getItems(options) {
      this.cancelCalls()
      this.cancelTokens = []
      const source = axios.CancelToken.source()
      this.cancelTokens.push(source)
      // const { itemsPerPage, page, sortBy, sortDesc } = options
      const { itemsPerPage, page, sortDesc } = options
      const sortBy = options.sortBy.map((x) => x.key)
      this.loading = true
      if (this.selectedCategory === 'tasksPending') {
        TaskService.paginateTasksPendingMOCDashboard(
          this.community.communityAbbreviation,
          {
            limit: itemsPerPage,
            page,
            sortBy,
            sortDesc
          },
          source.token
        )
          .then(result => {
            this.loading = false
            this.mocs = result.items
            this.totalItems = result.totalItems
          })
          .catch(error => {
            if (error.message !== 'CANCELLED_BY_USER') {
              this.loading = false
            }
          })
        return
      }
      if (this.selectedCategory === 'waitingForApproval') {
        ApprovalService.paginatePendingApprovalsMOCDashboard(
          this.community.communityAbbreviation,
          {
            limit: itemsPerPage,
            page,
            sortBy,
            sortDesc
          },
          source.token
        )
          .then(result => {
            this.loading = false
            this.mocs = result.items
            this.totalItems = result.totalItems
          })
          .catch(error => {
            if (error.message !== 'CANCELLED_BY_USER') {
              this.loading = false
            }
          })
        return
      }
      console.log(`getPaginatedMOCDashboard ${JSON.stringify({
          limit: itemsPerPage,
          page,
          sortBy,
          sortDesc
        })}`)
      MOCService.getPaginatedMOCDashboard(
        this.community.communityAbbreviation,
        this.selectedCategory,
        {
          limit: itemsPerPage,
          page,
          sortBy,
          sortDesc
        },
        source.token
      )
        .then(result => {
          this.loading = false
          this.mocs = result.items
          this.totalItems = result.totalItems
        })
        .catch(error => {
          if (error.message !== 'CANCELLED_BY_USER') {
            this.loading = false
          }
        })
    }
  },
  watch: {
    selectedCategory(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.options = { ...this.defaultOptions }
        this.mocs = []
        this.tableKey++; 
        console.log(`selectedCategory ${JSON.stringify(this.defaultOptions, null, 4)}`)
        this.getItems(this.defaultOptions)        
      }
    }
  }
}
</script>

<style scoped></style>
<style>
.v-data-table-footer__items-per-page span.v-select__selection-text {
  margin-left: 10px;
}
</style>